var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "70.000000pt",
    viewBox: "0 0 192.000000 263.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,263.000000) scale(0.100000,-0.100000)",
    fill: "#960019",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M807 2617 c-80 -26 -137 -95 -152 -185 -6 -35 -10 -42 -23 -36 -33 14 -121 16 -157 4 -81 -27 -145 -113 -145 -196 0 -43 -1 -46 -22 -39 -92 28 -178 11 -237 -47 -70 -68 -66 -27 -69 -717 -3 -683 -1 -719 54 -836 l28 -60 7 85 c4 47 12 98 18 113 8 19 11 230 11 663 l0 636 29 29 c39 39 96 40 140 3 l31 -25 2 -252 3 -252 58 -3 57 -3 0 356 c0 398 1 404 67 431 47 20 97 4 124 -40 18 -29 19 -54 19 -388 l0 -358 60 0 60 0 0 466 c0 323 3 472 11 487 32 63 107 76 161 28 l33 -29 3 -477 3 -476 57 3 57 3 5 368 5 369 28 24 c40 35 99 33 136 -4 l28 -27 6 -304 c4 -167 7 -422 7 -566 0 -302 4 -351 32 -366 34 -18 62 -2 181 105 86 78 125 107 152 112 99 18 156 -77 105 -176 -11 -21 -103 -125 -204 -232 l-185 -193 -1 -80 0 -79 61 59 c34 33 139 142 235 242 201 211 229 254 228 353 -1 135 -85 220 -216 220 -71 0 -138 -33 -216 -104 l-61 -58 -3 545 -3 544 -30 48 c-43 70 -118 109 -195 102 -30 -3 -65 -8 -76 -12 -19 -6 -22 -2 -26 45 -13 128 -155 218 -281 177z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 1045 c-289 -63 -473 -349 -406 -633 57 -239 268 -406 515 -406 295 1 524 230 524 524 0 253 -171 463 -419 515 -85 18 -130 18 -214 0z m164 -166 c116 -21 208 -88 262 -191 25 -48 28 -62 28 -158 0 -95 -3 -110 -27 -155 -27 -51 -80 -115 -95 -115 -7 1 -283 596 -283 612 0 4 10 9 23 11 12 2 25 5 28 6 3 0 32 -4 64 -10z m-134 -385 c76 -164 138 -303 138 -308 1 -5 -36 -6 -81 -4 -167 9 -284 108 -325 272 -14 57 -14 77 -4 133 7 36 19 80 28 97 23 46 84 117 96 113 6 -2 72 -138 148 -303z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access-denied.0da1c6291d0069f165f512a15df0edbc.svg";
export { ForwardRef as ReactComponent };